module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_04.89f38929.jpg";